/* src/app/views/dashboard/components/sidebar-nav/nav-item/profile-nav-item/profile-nav-item.component.scss */
/*# sourceMappingURL=profile-nav-item.component.css.map */
